module.exports = __webpack_public_path__ + "media/test2.67a7cd20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/test2.png
// module id = 678
// module chunks = 2